<div class="flex flex-col-reverse gap-2 md:flex-row">
  <!-- TODO: тут надо img, но появляется неведомый border, порисёрчить, как его убрать -->
  <div
    class="h-[166px] w-full rounded-3xl bg-[url('/assets/images/login/man_mobile.webp')] bg-cover md:h-[384px] md:w-[320px] md:bg-[url('/assets/images/login/man.webp')]"
  ></div>
  @if (!isAccountInfo()) {
    <div
      class="modal-dialog login-modal md:!w-[500px]"
      [ngClass]="{ 'md:!w-[406px]': telegramData()?.isCameFromBot }"
    >
      <button
        type="button"
        aria-label="close"
        class="modal__close"
        (click)="dialogRef.close()"
      ></button>

      <div
        class="login-dialog"
        [ngClass]="{ 'md:mt-[8rem]': telegramData()?.isCameFromBot }"
      >
        <div class="login-dialog__heading">
          <div class="login-dialog__title" i18n="@@login_dialog.auth.title">
            Вход
          </div>
          <div class="login-dialog__sub-title" i18n="@@login_dialog.auth.text">
            Добро пожаловать на CSFAIL
          </div>
        </div>

        <div class="login-dialog__steam">
          @if (telegramData()?.isCameFromBot) {
            <ui-login-dialog-button
              #telegramBtn
              method="telegram"
              classList="button_telegram"
              icon="icon_telegram"
              [text]="tgAuthText"
              [disabled]="!agreed()"
              [redirectToMain]="redirectToMain"
              (click)="telegramClick()"
            />
          } @else {
            <ui-login-dialog-button
              method="steam"
              classList="button_steam"
              icon="icon_steam"
              [text]="steamAuthText"
              [redirectToMain]="redirectToMain"
            />
          }
        </div>

        @if (!telegramData()?.isCameFromBot) {
          <div class="login-dialog__divider divider">
            <div class="divider__wrapper">
              <div class="divider__text" i18n="@@login_dialog.divider_text">
                или
              </div>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <ui-login-dialog-button
              method="telegram"
              classList="button_telegram"
              icon="icon_telegram"
              [text]="'TELEGRAM'"
              [redirectToMain]="redirectToMain"
            />

            @if (showCisMethods) {
              <ui-login-dialog-button
                method="vk"
                classList="button_vk"
                icon="icon_vk-auth"
                [text]="'VK'"
                [redirectToMain]="redirectToMain"
              />

              <ui-login-dialog-button
                method="yandex"
                classList="button_yandex"
                icon="icon_yandex-auth"
                [text]="'YANDEX'"
                [redirectToMain]="redirectToMain"
              />
            }

            <ui-login-dialog-button
              method="google"
              classList="button_google"
              icon="icon_google-auth"
              [text]="'GOOGLE'"
              [redirectToMain]="redirectToMain"
            />
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="modal-dialog login-modal !w-[300px] md:!w-[500px]">
      <div class="login-dialog flex flex-col !pt-4">
        <div
          class="h-[160px] w-full bg-[url('/assets/images/login/light.webp')] bg-contain bg-center bg-no-repeat"
        >
          <div
            class="mx-auto my-0 h-[146px] w-[194px] bg-[url('/assets/images/login/warning.webp')] bg-cover"
          ></div>
        </div>

        <div class="account_info">
          <span i18n="@@login_dialog.auth.telegram.part_one">
            Если у вас нет аккаунта, или ваш аккаунт уже привязан к вашему
            телеграмму
          </span>
          <span class="font-bold text-yellow-100">“{{ '@' + (telegramData()?.username || 'account_name') }}”</span>,
          <span i18n="@@login_dialog.auth.telegram.part_two">
            то нажмите кнопку
          </span>
          <span class="font-bold" i18n="@@login_dialog.auth.telegram.part_thee">
            “Войти через Telegram”</span
          >.
          <span i18n="@@login_dialog.auth.telegram.part_four">
            Если нет, то вы можете войти другими способами и привязать свой
            аккаунт для быстрого входа в дальнейшем.
          </span>
        </div>

        <div class="flex gap-[8px] pt-[24px] md:pt-[30px]">
          <button
            class="btn btn_blue !w-[calc(50%-4px)]"
            type="button"
            (click)="ok()"
          >
            <span i18n="@@login_dialog.auth.telegram.ok">Я Понял</span>
            <div class="icon icon_checked-circle-bold"></div>
          </button>
          <button
            class="btn btn_grey btn_grey-bordered !w-[calc(50%-4px)]"
            type="button"
            i18n="@@login_dialog.auth.telegram.cancel"
            (click)="isAccountInfo.set(false)"
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  }
</div>
